import mascotWriting from '@echo/brand/assets/mascot-complete-writing.png';
import { EXERCISE_COPY, exerciseKindSchema } from '@echo/core';
import { Button, SpeechBubble } from '@echo/ui-web';
import { useLingui } from '@lingui/react/macro';
import { createFileRoute, Navigate, useNavigate } from '@tanstack/react-router';
import { ContentFrame, ExercisePage } from '@/components/exercise-frame';

export const Route = createFileRoute('/_app/exercise/$kind/readback')({
  params: {
    parse: ({ kind }) => ({ kind: exerciseKindSchema.parse(kind) }),
    stringify: ({ kind }) => ({ kind }),
  },
  component: ExerciseReadbackPage,
});

/**
 * Writing's last step and its done screen: the coach asks the person to read what they
 * wrote out loud, right here, and "Back to home" returns to Home once they have, where the
 * routine's celebration waits. The attempt was saved on "Done writing"; this part is not timed.
 */
function ExerciseReadbackPage() {
  const { kind } = Route.useParams();
  const { t } = useLingui();
  const navigate = useNavigate();
  const copy = EXERCISE_COPY[kind];

  if (!copy.readback) {
    return <Navigate to="/exercise/$kind/complete" params={{ kind }} replace />;
  }

  return (
    <ExercisePage>
      <ContentFrame
        footer={
          <Button onClick={() => navigate({ to: '/', replace: true })}>{t`Back to home`}</Button>
        }
      >
        <SpeechBubble className="px-content-md">{t(copy.readback.body)}</SpeechBubble>
        <img
          src={mascotWriting}
          alt={t`A cheerful brain character with a finished page and a check mark`}
          className="size-[375px] max-w-full object-contain"
        />
      </ContentFrame>
    </ExercisePage>
  );
}
